// extracted by mini-css-extract-plugin
export default {"cls1":"YhBUy0xIXERgHna8p9bS","cls2":"lkSnVmI1SC9PtUctSVIg YhBUy0xIXERgHna8p9bS"};